import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getUnitRanap() {
  const response = await http.getData("/combo/unit-ranap").catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

export default {
  getUnitRanap
};
